import { InformationCircleIcon } from "@heroicons/react/24/outline";
import FileInputUploadFieldNew from "components/styledFormElements/FineInputUploadNew";
import InputField from "components/styledFormElements/InputField";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useObjectUrl } from "hooks/useObjectUrl";
import { OnboardingFormValues } from "containers/Protected/Settings/OnboardingSettings/interface";

const AuthenticationSettings: React.FC = () => {
    const {
        register,
        control,
        formState: { errors },
    } = useFormContext<OnboardingFormValues>();

    const watchedLogo = useWatch({ control, name: 'auth.a_image' })
    const aImagePreview = useObjectUrl(watchedLogo)
    
    return (
        <div className="settings-card">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                        Top Image {<span className="text-red-700">*</span>}

                        {(
                            <span className="relative group ml-1 inline-block">
                                <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-pointer inline" />
                                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50">
                                    '2:3 aspect ratio',
                                    'JPG / PNG',
                                    '≤ 1 MB',
                                </div>
                            </span>
                        )}
                    </label>

                    <FileInputUploadFieldNew
                        name="auth.a_image"
                        control={control}
                        errors={errors}
                        preview={aImagePreview}
                        allowedTypes={[
                            'image/jpeg',
                            'image/png',
                            'image/jpg',
                        ]}
                    />
                </div>
                <InputField
                    label="Title"
                    required
                    helpText='Main heading shown on the authentication screen (e.g., "Enter OTP to verify").'
                    placeholder="Enter Title"
                    type="text"
                    register={register("auth.a_title")}
                    error={errors?.auth?.a_title?.message}
                />
                <InputField
                    label="Sub Title"
                    required
                    helpText='Secondary text displayed below the title'
                    placeholder="Enter Sub Title"
                    type="text"
                    register={register("auth.a_subTitle")}
                    error={errors?.auth?.a_subTitle?.message}
                />
                <InputField
                    label="CTA Text"
                    required
                    helpText='Primary button text used to proceed after entering the OTP (e.g., "Verify", "Continue").'
                    placeholder="Enter CTA Text"
                    type="text"
                    register={register("auth.a_ctaText")}
                    error={errors?.auth?.a_ctaText?.message}
                />
            </div>
        </div>
    );
};

export default AuthenticationSettings;
